const CopyIcon = ({ fill }) => {

    return (
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" xmlSpace="preserve">
            <path d="M15,1H4C2.9,1,2,1.9,2,3v13c0,0.55,0.45,1,1,1s1-0.45,1-1V4c0-0.55,0.45-1,1-1h10c0.55,0,1-0.45,1-1S15.55,1,15,1z"
                fill={fill ? fill : '#FFF'} />
            <path d="M19,5H9C7.34,5,6,6.34,6,8v12c0,1.66,1.34,3,3,3h10c1.66,0,3-1.34,3-3V8C22,6.34,20.66,5,19,5z M19,21H9c-0.55,0-1-0.45-1-1
                V8c0-0.55,0.45-1,1-1h10c0.55,0,1,0.45,1,1v12C20,20.55,19.55,21,19,21z"
                fill={fill ? fill : '#FFF'} />
        </svg>
    )
}

export default CopyIcon
